module.exports = __webpack_public_path__ + "media/images/country_flags/lr-d8dd5e0c4998014cd1583a178764e923.png";